module.exports = __webpack_public_path__ + "static/media/ddbdb4ba.jpg";